module.exports = __webpack_public_path__ + "static/img-test-indra-7002cc5537f493a5efa438dc4bbf3530.jpg";